import { version } from "../../package.json";

export const LIB_VERSION = version;
